/* @flow */

export default class SecurityMenu {
  pageName: string;
  elementName: string;
  userRoleId: number;
  hasAccess: boolean;
}
